export const environment = {
  production: false,
  env: "qa",
  // apiHost: "https://api.qa-beta.zceppa.com/",
  apiHost: "https://api.demo.zceppa.com/",
  adminApiHost: "https://admin-api.demo.zceppa.com/",
  widgetDomain: "https://widget.zceppa.com/",
  spritePath: "assets/sprites/sprite.svg",
  fbAppId: "2262024527378539",
  pusher: {
    key: "010d0565b3d2f39e34df",
    cluster: "ap2",
  },
  feedbackApi: {
    apiKey: "ZV8By8-BUFSFJ0i-bsqAKWojhi0fP6WuthE5gtAg8Rk",
    clientId: "d75ba8d2-a1b2-4efd-8210-370ccee55f3a",
  },
};